import { render, staticRenderFns } from "./TypingText.vue?vue&type=template&id=22c03084&scoped=true&"
import script from "./TypingText.vue?vue&type=script&lang=js&"
export * from "./TypingText.vue?vue&type=script&lang=js&"
import style0 from "./TypingText.vue?vue&type=style&index=0&id=22c03084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c03084",
  null
  
)

export default component.exports